export const MIN_ZOOM_TO_DISPLAY_POPUP = 13;
// import ListingMapPopup from "components/v2/Listings/ListingMapPopup";
import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectors as ListingreducerSelectors } from "redux/slices/v2/ListingReducer";
import { RootState } from "types/RootState";
import styles from "./ListingsSortAndMapSwitch.module.css";

import dynamic from "next/dynamic";

import { selectors as ListingsReducerSelectors } from "../../../../../../redux/slices/v2/ListingReducer";
import {
  linkSearchItems,
  norm,
} from "components/v2/Listings/ListingsRouterUrlHelper";
import { province_to_slug } from "pagesHelpers/ListingPagesHepler/SlugTransformation";
import ListingsPopup from "../ListingsPopup";

const ListingMapPopup = dynamic(
  () => import("components/v2/Listings/ListingMapPopup"),
  {
    ssr: false,
  }
);

export default function ListingsSortAndMapSwitch({
  transaction_type,
  mapVsList,
  onMapVsListChange,
  setSortDialogVisisble,
  onListingPress,
  listings,
}: {
  transaction_type: RootState["listingsV2"]["searchPayload"]["transaction_type"];
  mapVsList: "MAP" | "LIST";
  onMapVsListChange: (mapVsList: "MAP" | "LIST") => void;
  setSortDialogVisisble: (visible: boolean) => void;
  onListingPress: (listing: RootState["listingsV2"]["currentListing"]) => void;
  listings: any;
}) {
  const { t, lang } = useTranslation("commonAnnonces");
  const favListings = useSelector(
    ListingreducerSelectors.favoriteListingsSelactor
  );

  const mapListing = useSelector(ListingreducerSelectors.mapListingSelactor);

  const showPopup: any = useSelector(
    ListingsReducerSelectors.showPopupSelactor
  );

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 990) setIsMobile(true);
      else setIsMobile(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 990) setIsMobile(true);
    else setIsMobile(false);
  }, []);

  const searchPayload = useSelector(
    ListingsReducerSelectors.searchPayloadSelector
  );
  const handleLinksRedirect = (typeRedirect: string) => {
    const {
      region,
      controlBy,
      meublee,
      no_trigger_search,
      page,
      ...filteredPayload
    } = searchPayload;

    let copySP = {};
    if (filteredPayload.bounds) {
      copySP["bounds"] = [
        filteredPayload.bounds._sw.lat,
        filteredPayload.bounds._sw.lng,
        filteredPayload.bounds._ne.lat,
        filteredPayload.bounds._ne.lng,
      ];
      if (filteredPayload.exclusivite) {
        copySP["exclusivite"] = filteredPayload.exclusivite;
      }
    } else if (window) {
      if (window.cartedesannonces) {
        if (window.cartedesannonces.getBounds) {
          let boundsref = window.cartedesannonces.getBounds();
          copySP["lat"] = window.cartedesannonces.getCenter().lat;
          copySP["lng"] = window.cartedesannonces.getCenter().lng;
          copySP["zoom"] = window.cartedesannonces.getZoom();
          copySP["bounds"] = [
            boundsref._sw.lat,
            boundsref._sw.lng,
            boundsref._ne.lat,
            boundsref._ne.lng,
          ];
        }
      }
    }

    linkSearchItems.map((item) => {
      if (
        (filteredPayload[item] && filteredPayload[item].length) ||
        (typeof filteredPayload[item] == "number" &&
          parseInt(filteredPayload[item].toString()))
      ) {
        copySP[item] = filteredPayload[item];
      }
    });
    if (filteredPayload["province"]) {
      copySP["province"] = province_to_slug[filteredPayload["province"]];
    }

    copySP["zoom"] = searchPayload.zoom ? searchPayload.zoom : 8;

    copySP["commune"] = searchPayload.commune
      ? norm(searchPayload.commune)
      : "";
    copySP["vendu"] = filteredPayload["vendu"];
    const u = new URLSearchParams(copySP).toString();

    let link = `/${lang}/${typeRedirect}.htm${u ? `?${u}` : ""}`;

    window.location.href = link;
  };

  const listingsLoading: any = useSelector(
    ListingreducerSelectors.loadingSelactor
  );
  useEffect(() => { }, [listingsLoading]);
  useEffect(() => {
    if (mapListing?.listing) {
    }
  }, [mapListing?.listing]);
  return (
    <>
      {showPopup == 1 && mapVsList === "MAP" && isMobile && !listingsLoading ? (
        <ListingsPopup
          listings={
            mapListing.listing
              ? [
                {
                  ...mapListing.listing,
                  images: mapListing.listing.images
                    ? mapListing.listing.images
                      .toString()
                      .replace('"', "")
                      .replace("[", "")
                      .replace("]", "")
                    : "",
                },
                ...listings.filter((e) => {
                  return e._id != mapListing.listing._id;
                }),
              ]
              : listings
          }
          isMobile={isMobile}
          favListings={favListings}
          onListingPress={onListingPress}
        />
      ) : null}
      <div
        id="main-container-map-list"
        style={{
          bottom: "0px",
        }}
        className={styles.mainContainer}
      >
        <div className={styles.buttonsContainer}>
          <div className={styles.buttonsInnerContainer}>
            <div className={styles.buttonContainer}>
              <button
                className={styles.button}
                onClick={() => {
                  handleLinksRedirect(mapVsList == "LIST" ? "map" : "list");
                }}
                data-tracking="click"
                data-value="map-switch"
              >
                {mapVsList === "MAP" ? (
                  <>
                    <i
                      aria-hidden
                      className="fas fa-list-ul"
                      style={{ marginRight: "8px" }}
                    ></i>
                    {t("Annonces")}
                  </>
                ) : (
                  <>
                    <i
                      aria-hidden
                      className="far fa-map"
                      style={{ marginRight: "8px" }}
                    ></i>
                    {t("Carte")}
                  </>
                )}
              </button>
            </div>
            {mapVsList === "LIST" && (
              <div className={styles.buttonContainer}>
                <button
                  className={styles.button}
                  onClick={() => {
                    setSortDialogVisisble(true);
                  }}
                  data-tracking="click"
                  data-value=""
                >
                  <svg
                    width="19"
                    height="18"
                    viewBox="0 0 19 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.5 12.75H12.5M3.5 9H10.25M3.5 5.25H8M14 9.75V3.75M14 3.75L16.25 6M14 3.75L11.75 6"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  {t("Trier")}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
